<div class="modal-border">
  <ion-header>
    <ion-toolbar>
      <ion-row
        ><ion-col> <ion-title>What's new on XRS</ion-title></ion-col>
        <ion-buttons>
          <ion-button (click)="dismissModal()" size="large" slot="end">
            <ion-icon name="close"></ion-icon>
          </ion-button> </ion-buttons
      ></ion-row>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <p>
      Welcome back,
      {{ globals.XRSUser != null ? globals.XRSUser.Firstname : "" }}!
    </p>

    <div
      *ngIf="
        notifications &&
        notifications.length === 0 &&
        incomplete &&
        incomplete.length === 0
      "
    >
      <p>
        There are no lessons assigned to you right now. Speak to your
        facilitator if you think there should be lessons assigned to you.
      </p>
    </div>

    <div
      *ngIf="notifications && notifications.length == 1"
      class="hover-background"
      (click)="navigateToURL('/training')"
      style="padding-top: 10px; padding-bottom: 10px; padding-left: 10px"
    >
      You currently have {{ lessonCount }} lesson assigned to you:
      <span [innerHTML]="getItalicLessons(firstTwoNotifications)"></span>
    </div>
    <div
      *ngIf="notifications && notifications.length > 1"
      class="hover-background"
      (click)="navigateToURL('/training')"
      style="padding-top: 10px; padding-bottom: 10px; padding-left: 10px"
    >
      You currently have {{ lessonCount }} lessons assigned to you including:
      <span [innerHTML]="getItalicLessons(firstTwoNotifications)"></span>
    </div>

    <div
      *ngIf="incomplete && incomplete.length == 1"
      class="hover-background"
      (click)="navigateToURL('/training')"
      style="padding-top: 10px; padding-bottom: 10px; padding-left: 10px"
    >
      You have yet to complete {{ incompleteCount }} lesson:
      <span [innerHTML]="getItalicLessons(firstTwoIncomplete)"></span>
    </div>

    <div
      *ngIf="incomplete && incomplete.length > 1"
      class="hover-background"
      (click)="navigateToURL('/training')"
      style="padding-top: 10px; padding-bottom: 10px; padding-left: 10px"
    >
      You have yet to complete {{ incompleteCount }} lessons including:
      <span [innerHTML]="getItalicLessons(firstTwoIncomplete)"></span>
    </div>
  </ion-content>
</div>
